import React, { useEffect, useState } from 'react';
import { addShoppingList, updateShoppingList } from 'services/api/shoppingLists';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddShoppingListModal = props => {
  const [name, setName] = useState<string>('');
  const [isPublic, setIsPublic] = useState<boolean>(false);
  const [isFeatured, setIsFeatured] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    toggleModal,
    onSuccess,
    listDetails: { objectId: listId = '', name: nameFromProps = '', isPublic: isPublicFromProps = false, isFeatured: isFeaturedFromProps = false } = {},
  } = props;

  useEffect(() => {
    if (listId) {
      setName(nameFromProps);
      setIsPublic(isPublicFromProps);
      setIsFeatured(isFeaturedFromProps);
    }
  }, []);
  const handleSubmit = async () => {
    setLoading(true);
    let response;
    try {
      if (listId) {
        response = await updateShoppingList({
          id: listId, name, isPublic, isFeatured,
        });
      } else {
        response = await addShoppingList({
          name, isPublic, isFeatured,
        });
      }
      onSuccess(response.toJSON());
      showSuccess('Shopping List added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['modal-title']}>{listId ? 'Edit' : 'Add'} Shopping List</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={'mb-3'}>
            <div className={styles['label']}>Name</div>
            <input
              className={'form-control'}
              value={name}
              onChange={e => setName(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className='d-flex flex-column flex-md-row flex-lg-row'>
            <div className={styles['checkbox-group']}>
              <div className={styles['checkbox-label']}>Public</div>
              <input
                type={'checkbox'}
                className={'form-control'}
                checked={isPublic}
                onChange={e => setIsPublic(e.target.checked)}
              />
            </div>
            <div className={styles['checkbox-group']}>
              <div className={styles['checkbox-label']}>Featured</div>
              <input
                type={'checkbox'}
                className={'form-control'}
                checked={isFeatured}
                onChange={e => setIsFeatured(e.target.checked)}
              />
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            type={'button'}
            disabled={loading}
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            className={styles['submit-button']}
            onClick={handleSubmit}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddShoppingListModal;